import React, { Component } from 'react';

import Icon from './icon.js';
import constants from './constants';
import { insertDataBlock } from 'megadraft';

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();

    const src = window.prompt('Enter a Youtube URL');

    if (!src) {
      return;
    }

    const data = { src: src, type: constants.PLUGIN_TYPE, display: 'small' };

    this.props.onChange(insertDataBlock(this.props.editorState, data));
  }

  render() {
    return (
      <button
        className={this.props.className}
        type="button"
        onClick={this.onClick}
        title={constants.PLUGIN_NAME}
      >
        <Icon className="sidemenu__button__icon" />
      </button>
    );
  }
}
